import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { FileText, Upload, X } from 'lucide-react';
import './FormStyles.css';

const DocumentsForm = ({ onSubmit, onBack, initialData }) => {
  const [data, setData] = useState({
    Document: initialData?.Document || '',
    photos: null,
    Documentupload: null,
    issue_date: initialData?.issue_date || '',
    expired_date: initialData?.expired_date || ''
  });
  const [photoPreview, setPhotoPreview] = useState(null);
  const [uploadPreview, setUploadPreview] = useState(null);

  const documentTypes = ['Passport', 'NIRA', 'Licence'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.startsWith('image/')) {
        toast.error('Please select an image file');
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        toast.error('File size should be less than 5MB');
        return;
      }
      setData(prev => ({ ...prev, [field]: file }));
      
      const reader = new FileReader();
      reader.onloadend = () => {
        if (field === 'photos') setPhotoPreview(reader.result);
        else setUploadPreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const removeFile = (field) => {
    setData(prev => ({ ...prev, [field]: null }));
    if (field === 'photos') setPhotoPreview(null);
    else setUploadPreview(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (!data.Document) {
      toast.error('Please select document type');
      return;
    }
    if (!data.issue_date) {
      toast.error('Please select issue date');
      return;
    }
    if (!data.expired_date) {
      toast.error('Please select expiry date');
      return;
    }
    if (!data.photos) {
      toast.error('Please upload photo');
      return;
    }

    // JUST PASS DATA TO PARENT - NO API CALL
    console.log('DocumentsForm submitting data to parent');
    onSubmit({ ...data });
  };

  return (
    <div className="form-card">
      <h2 className="form-title">
        <FileText size={24} /> Documents
      </h2>

      <form className="dynamic-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Document Type *</label>
          <select name="Document" value={data.Document} onChange={handleChange} required>
            <option value="">Select Document Type</option>
            {documentTypes.map(type => (
              <option key={type} value={type}>{type}</option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label>Issue Date *</label>
          <input type="date" name="issue_date" value={data.issue_date} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Expiry Date *</label>
          <input type="date" name="expired_date" value={data.expired_date} onChange={handleChange} required />
        </div>

        <div className="form-group">
          <label>Photo *</label>
          <div className="file-upload-area">
            <input
              type="file"
              id="photo-upload"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'photos')}
              style={{ display: 'none' }}
            />
            <button
              type="button"
              className="upload-button"
              onClick={() => document.getElementById('photo-upload').click()}
            >
              <Upload size={18} /> Choose Photo
            </button>
            {photoPreview && (
              <div className="preview-container">
                <img src={photoPreview} alt="Preview" className="preview-image" />
                <button
                  type="button"
                  className="remove-button"
                  onClick={() => removeFile('photos')}
                >
                  <X size={14} />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="form-group">
          <label>Document Upload (Optional)</label>
          <div className="file-upload-area">
            <input
              type="file"
              id="document-upload"
              accept="image/*"
              onChange={(e) => handleFileChange(e, 'Documentupload')}
              style={{ display: 'none' }}
            />
            <button
              type="button"
              className="upload-button"
              onClick={() => document.getElementById('document-upload').click()}
            >
              <Upload size={18} /> Choose Document
            </button>
            {uploadPreview && (
              <div className="preview-container">
                <img src={uploadPreview} alt="Preview" className="preview-image" />
                <button
                  type="button"
                  className="remove-button"
                  onClick={() => removeFile('Documentupload')}
                >
                  <X size={14} />
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="form-actions">
          <button type="button" onClick={onBack} className="back-btn">Back</button>
          <button type="submit" className="submit-btn">Next →</button>
        </div>
      </form>
    </div>
  );
};

export default DocumentsForm;